/* unplugin-vue-components disabled */import script from "./Dictionary.vue?vue&type=script&setup=true&lang=tsx"
export * from "./Dictionary.vue?vue&type=script&setup=true&lang=tsx"

import "./Dictionary.vue?vue&type=style&index=0&id=8e0f102a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e0f102a"]])

export default __exports__